import { render, staticRenderFns } from "./contractdetail.vue?vue&type=template&id=747f76e2&"
import script from "./contractdetail.vue?vue&type=script&lang=ts&"
export * from "./contractdetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports